import { https } from './api'

export default class {
  constructor() {
    this.instance = https()
  }

  login = (data) => {
      return this.instance({
        method: 'POST',
        url: '/auth/login',
        timeout: 240000,
        data,
      })
  }

  loginSpecial = (data) => {
    return this.instance({
      method: 'POST',
      url: '/auth/loginSpecial',
      timeout: 240000,
      data,
    })
  }

  checkStudentLogin = (data) => {
    return this.instance({
      method: 'POST',
      url: '/auth/studentValidation',
      timeout: 240000,
      data,
    })
  }
}
